import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';

import Banner from '../components/banner/banner.component';
import Partner from '../components/partner/partner.component';
import CompanyMission from '../components/company-mission/company-mission.component';
import Newsletter from '../components/newsletter/newsletter.component';
import Calculator from '../components/calculator/calculator.component';
import OperationalMethods from '../components/operational-methods/operational-methods.component';
import Testimonials from '../components/testimonials/testimonials.component';
import RecentNews from '../components/recent-news/recent-news.component';

// Promotion over
// import Promo from '../components/promo/promo.component';

type LandingPageProps = {
  data: GatsbyTypes.StrapiLinkedArticlesPreviewQuery;
};

export const query = graphql`
  query StrapiLinkedArticlesPreview {
    allStrapiLinkedArticle(filter: { status: { eq: "published" } }) {
      edges {
        node {
          title
          hyperlink
          publishedAt
        }
      }
    }
  }
`;

const LandingPage: React.FC<LandingPageProps> = ({ data }) => {
  return (
    <>
      <Helmet title="Landing" />
      <Banner />
      <Partner />
      <CompanyMission />
      <Calculator />
      <OperationalMethods />
      <Testimonials />
      <RecentNews
        subtitle="News"
        news={data.allStrapiLinkedArticle.edges.map(
          ({ node: { title, hyperlink, publishedAt } }) => ({
            name: title,
            date: publishedAt,
            link: hyperlink,
            photoUrl: require('../assets/photos/logo-blue.png'),
          })
        )}
        maxNewsCount={3}
      />
      <Newsletter />
    </>
  );
};

export default LandingPage;
